module.exports = __webpack_public_path__ + "img/csr5.10eb47aa.jpg";